export const platformsTitleNames: Record<string, string> = {
  'paid-marketing': 'Paid Marketing',
  botzapping: 'Bot Mitigation',
}

export const routesNames = {
  '': 'Home',
  login: 'Login',
  signup: 'Signup',
  onboarding: 'Onboarding',
  'forgot-password': 'Forgot Password',
  'reset-password': 'Reset Password',
  'account-settings': 'Account Settings',
  'user-profile': 'User Profile',
  'domain-management': 'Domain Management',
  'paid-marketing/dashboard': 'Dashboard',
  'paid-marketing/platforms': 'Platforms',
  'paid-marketing/domain/detailed-view': 'Detailed View',
  'paid-marketing/detection-settings': 'Detection Settings',
  'paid-marketing/domain/detection-settings': 'Detection Settings',
  botzapping: 'Bot Mitigation',
  'botzapping/dashboard': 'Dashboard',
  'botzapping/blocks-report': 'Detailed Report',
  'botzapping/protection-setup': 'Protection Setup',
  'help-center-link': 'Help Center',
}

export const AUTH_ROUTES = ['login', 'signup', 'forgot-password', 'reset-password']

export const PUBLIC_ROUTES = [...AUTH_ROUTES, 'help-center-link']

export const VIEWER_FORBIDDEN_ROUTES = [
  '/onboarding',
  '/account-settings',
  '/paid-marketing/platforms',
  '/paid-marketing/detection-settings',
]
